import React from 'react';
import Text from '../text';
import ButtonGroup from '../button-group';
import Button from '../button';
import Modal from '../modal';
import Render from '../render';
import noop from '../utils/noop';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
function SubmitDialog({
  width = 376,
  height = 220,
  offsetX = 0,
  offsetY = 0,
  minWidth = 312,
  minHeight = 220,
  captions: { title, description, discard, submit, cancel },
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a...
  onDiscard = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a...
  onSubmit = null,
  onCancel = noop,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a...
  onDialogMainAction = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a...
  onDialogCancel = null,
}) {
  const onSubmitAction = () => {
    if (onDialogMainAction) onDialogMainAction();
    onSubmit();
  };

  const onDiscardAction = () => {
    if (onDialogCancel) onDialogCancel();
    onDiscard();
  };

  const onCancelAction = () => {
    if (onDialogCancel) onDialogCancel();
    onCancel();
  };

  return (
    <Modal
      overlay="visible"
      centered
      resizable={false}
      draggable={false}
      className="ws-submit-dialog"
      width={width}
      height={height}
      minWidth={minWidth}
      minHeight={minHeight}
      offsetX={offsetX}
      offsetY={offsetY}
      handleSubmit={onSubmitAction}
      handleCancel={onCancelAction}
    >
      <Text type="heading-5" className="ws-submit-dialog__title">
        {title}
      </Text>
      <div className="ws-submit-dialog__content">
        <Text theme="grey">{description}</Text>
      </div>
      <ButtonGroup className="ws-submit-dialog__buttons">
        <Render if={!!onSubmit}>
          <Button stretch="block" size="large" onClick={onSubmitAction}>
            {submit}
          </Button>
        </Render>
        <Render if={!!onDiscard}>
          <Button stretch="block" size="large" onClick={onDiscardAction}>
            {discard}
          </Button>
        </Render>
        <Button stretch="block" size="large" onClick={onCancelAction}>
          {cancel}
        </Button>
      </ButtonGroup>
    </Modal>
  );
}

export default SubmitDialog;
